export default "HUD\n";